import {AuthService} from '@/api/AuthService';
import {StoreProxy} from "@/api/common/StoreProxy";

export default {
    name: 'Login',
    data() {
        return {
            userId: '',
            password: '',
            failedLogin: {
                attempted: false,
                message: ''
            }
        }
    },
    computed:{
        versionLabel(){
            return `${$build.version}-${$build.shortCommitHash} | build: ${$build.buildNumber} ${$build.date}`
        }
    },
    mounted(){
        let authService = new AuthService();

        let vm = this;

        authService.reValidate().then(data => {

            authService.getProfile(data, (profile) => {

                StoreProxy.setLogin(vm.$store, data.jwt, data.sessionId, profile);
                vm.$router.push('dashboard');

            }, (e) => {

                this.$notify.error({
                    title: 'Internal Error',
                    message: 'Unable to retrieve user profile!'
                });

                StoreProxy.setLogout(vm.$store);

            });

        }).catch(error => {
            if (error != null) {
                console.error(error);
            }

            StoreProxy.setLogout(vm.$store);
        });

    },
    methods: {
        login() {
            let authApi = new AuthService(process.env.VUE_APP_AUTH_URL);

            authApi.login(this.userId, this.password).then(

                authResult => {

                    if (authResult.authenticated) {

                        authApi.getProfile(authResult, (profile) => {

                            if (!profile.roles){

                                this.failedLogin.attempted = true;
                                this.failedLogin.message = "You are not an administrator!";
                                StoreProxy.setLogout(this.$store);
                                return;
                            }

                            let isAdmin = false;
                            profile.roles.forEach(function (role){
                                if (role === 'ADMIN'){
                                    isAdmin = true;
                                }
                            });

                            if (!isAdmin){
                                this.failedLogin.attempted = true;
                                this.failedLogin.message = "You are not an administrator!";
                                StoreProxy.setLogout(this.$store);
                                return;
                            }

                            StoreProxy.setLogin(this.$store, authResult.jwt, authResult.sessionId, profile);

                            this.$router.push('dashboard');

                        }, (e) => {

                            StoreProxy.setLogout(this.$store);
                            this.$notify.error({
                                title: 'Internal Error',
                                message: 'Unable to retrieve logged user profile.!.'
                            });

                        });
                    } else {

                        this.failedLogin.attempted = true;
                        this.failedLogin.message = authResult.message;
                    }

                }
            ).catch((e) => {
                this.failedLogin.attempted = true;
                this.failedLogin.message = "Server Error - Please try again later. ";

                console.error(e);
            })
        }
    }
}
